/// <reference path="../interfaces/bootstrap.datepicker.d.ts" />
//https://github.com/eternicode/bootstrap-datepicker

module Tapas.Bindings {
    export class DatePicker {
        public init(element: HTMLElement, valueAccessor: () => DatepickerOptions, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var ele = $(element);
            var params = valueAccessor() || {};
            var startDate = params.startDate || new Date()

            ele.datepicker({
                format: params.format || 'dd-mm-yyyy', //skal komme fra server
                autoclose: params.autoclose || true,
                keyboardNavigation: params.keyboardNavigation || true,
                language: params.language || 'da', //skal komme fra server
                todayHighlight: params.todayHighlight || true,
                startDate: startDate,
                endDate: params.endDate || null,
                calendarWeeks: params.calendarWeeks || false,
                daysOfWeekDisabled: params.daysOfWeekDisabled || null,
                weekStart: params.weekStart || 1,
                orientation: params.orientation || "bottom"
            });

            ele.datepicker("setDate", startDate);
        }
    }
    ko.bindingHandlers['datePicker'] = new DatePicker();
}

//languages
//DK
$.fn.datepicker.dates['da'] = {
    days: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"],
    daysShort: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
    daysMin: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
    months: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"],
    monthsShort: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    today: "I Dag",
    clear: "Nulstil"
};

//EN
$.fn.datepicker.dates['en-GB'] = {
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    today: "Today",
    monthsTitle: "Months",
    clear: "Clear",
    weekStart: 1,
    format: "dd/mm/yyyy"
};

//SV
$.fn.datepicker.dates['sv'] = {
    days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
    daysShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
    daysMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
    months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
    today: "Idag",
    format: "yyyy-mm-dd",
    weekStart: 1,
    clear: "Rensa"
};

//NO
$.fn.datepicker.dates['no'] = {
    days: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
    daysShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
    daysMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
    months: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
    today: 'I dag',
    clear: 'Nullstill',
    weekStart: 1,
    format: 'dd.mm.yyyy'
};

//FI
$.fn.datepicker.dates['fi'] = {
    days: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"],
    daysShort: ["sun", "maa", "tii", "kes", "tor", "per", "lau"],
    daysMin: ["su", "ma", "ti", "ke", "to", "pe", "la"],
    months: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"],
    monthsShort: ["tam", "hel", "maa", "huh", "tou", "kes", "hei", "elo", "syy", "lok", "mar", "jou"],
    today: "tänään",
    clear: "Tyhjennä",
    weekStart: 1,
    format: "d.m.yyyy"
};

//Get more languages at: https://github.com/eternicode/bootstrap-datepicker/tree/master/js/locales